interface Props {
  isAffiliate?: boolean;
}

export default function StepComplete({ isAffiliate = false }: Props) {
  return (
    <div style={{ textAlign: 'center', padding: '10px 0' }}>
      <div
        style={{
          width: '70px',
          height: '70px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #fa7c9e, #ff5c73)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
        }}
      >
        <i className="ri-check-line" style={{ color: 'white', fontSize: '32px' }} />
      </div>

      <h3
        style={{
          fontWeight: 900,
          fontSize: '18px',
          color: '#ff5c73',
          marginBottom: '16px',
          lineHeight: 1.4,
        }}
      >
        {isAffiliate ? '登録ありがとうございました！' : 'ご回答ありがとうございました！'}
      </h3>

      <p style={{ fontSize: '14px', color: '#555', lineHeight: 1.9, marginBottom: '20px' }}>
        1営業日以内に専属アドバイザーより<br />
        ご登録いただいた電話番号にご連絡いたします。<br />
        <br />
        <span style={{ fontSize: '13px', color: '#888' }}>
          ※非通知・番号非表示からのお電話の場合、<br />
          折り返しができない場合がございます。
        </span>
      </p>

      {!isAffiliate && (
        <div
          data-track-view="view_complete_line_box"
          style={{
            background: 'rgba(6, 199, 85, 0.05)',
            border: '1px solid rgba(6, 199, 85, 0.3)',
            borderRadius: '16px',
            padding: '20px 16px',
            marginTop: '4px',
          }}
        >
          <p style={{ fontSize: '14px', fontWeight: 700, color: '#333', marginBottom: '8px' }}>
            ＼ LINEの友だち追加をお願いします ／
          </p>
          <p style={{ fontSize: '13px', color: '#555', lineHeight: 1.8, marginBottom: '16px' }}>
            求人のご紹介やご質問への回答を、<br />
            LINEでスムーズに受け取れます。
          </p>
          <a
            href="https://liff.line.me/2008134586-4lPmuiqP?utm_campaign=lp07"
            target="_blank"
            rel="noopener noreferrer"
            data-track="LINE友だち追加（回答完了）"
            style={{
              display: 'block',
              width: '100%',
              background: '#06C755',
              color: 'white',
              fontWeight: 700,
              fontSize: '15px',
              padding: '14px 0',
              borderRadius: '50px',
              textDecoration: 'none',
              boxShadow: '0 4px 12px rgba(6, 199, 85, 0.35)',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
            }}
          >
            <i className="ri-line-fill" style={{ fontSize: '20px', verticalAlign: 'middle', marginRight: '8px' }} />
            LINEで友だち追加
          </a>
        </div>
      )}
    </div>
  );
}